import React from 'react';
import Section from './Section';

const FinalCTA = () => {
  return (
    <div className="bg-zinc-950 text-white text-center">
      <Section className="py-32">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-black tracking-tight mb-8">
            You can’t control what you don’t understand.
          </h2>
          <p className="text-xl text-zinc-400 mb-12">
            Take back control of your digital footprint today.
          </p>
          <a href="#pricing" className="inline-block px-10 py-5 bg-white text-zinc-950 font-bold rounded-xl hover:bg-zinc-200 transition-colors text-lg shadow-xl shadow-white/10">
            Get My Data Risk Audit
          </a>
        </div>
      </Section>
    </div>
  );
};

export default FinalCTA;